import * as forms from "@client/forms";
import * as typography from "@client/shared/typography";
import {ManagerLayout} from "@client/site/ManagerLayout";
import * as utils from "@client/utils";
import {server} from "@reactivated";
import React from "react";

import {ClientNavigation} from "./ClientManagerPlanner";

export const Template = (props: server.manager.templates.CreateClient) => {
    const form = forms.useForm(props.form);
    const title = "Create client";
    const quantityText =
        props.next_quantity === 1
            ? "for a single client"
            : ` for ${props.next_quantity} clients`;
    const [isSubmitting, setIsSubmitting] = React.useState(false);
    const action = isSubmitting === false ? "Invite" : "Processing...";

    return (
        <ManagerLayout narrow title={title} currentClientManagerId={null}>
            <form
                className="flex flex-col space-y-[15px]"
                onSubmit={forms.guard([form], () => setIsSubmitting(true))}
                noValidate
                method="POST"
                action=""
            >
                <forms.CSRFToken />
                <forms.FormErrors form={form} />
                <ClientNavigation>
                    <typography.Header>{title}</typography.Header>
                </ClientNavigation>
                {props.is_first_client && (
                    <div className="rounded-md bg-sky-100 p-4 text-sky-900">
                        To start you off, invite yourself as a client. This won’t count
                        towards your billing.
                    </div>
                )}
                <fieldset className="manager-form max-w-[400px] space-y-[15px]">
                    <legend>Basic information</legend>
                    <forms.Fields form={form} exclude={["meal_plan"]} />
                </fieldset>
                {/*
                <fieldset className="manager-form space-y-[15px] max-w-[400px]">
                    <legend>Optional settings</legend>
                    <forms.Fields form={form} fields={["meal_plan"]} />
                </fieldset>
                */}
                <typography.P>
                    You will be charged a prorated amount of{" "}
                    <strong>{utils.formatCurrency(props.immediate_total)}</strong> after
                    creating this client.
                </typography.P>
                {props.is_first_client == false && (
                    <typography.P>
                        Going forward, you’ll be billed{" "}
                        <strong>{utils.formatCurrency(props.next_invoice_sum)}</strong>{" "}
                        every month {quantityText}.
                    </typography.P>
                )}
                <typography.P>
                    Your client will receive instructions to setup their account and
                    confirm you as their manager.
                </typography.P>
                <div>
                    <typography.Button submit disabled={isSubmitting}>
                        {action}
                    </typography.Button>
                </div>
            </form>
        </ManagerLayout>
    );
};
